export const DocumentsRoutes = {
    documents: (origin: string) => `${origin}/search/document`,
    documentBlob: (origin: string) => `${origin}/document/download`,
    documentPreviewLink: (origin: string) => `${origin}/document/preview`,
    documentDownloadLink: (origin: string) => `${origin}/document/download`,
};
